import * as React from 'react';

import { Section } from '../../Section';
import { LayoutBlock } from '../../LayoutBlock';

interface ISectionWrapperProps {
  children: React.ReactNode | React.ReactNode[];
  ref?: React.Ref<HTMLDivElement>;
}

export function SectionWrapper({ children, ref }: ISectionWrapperProps): React.JSX.Element {
  return (
    <LayoutBlock ref={ref} data-testid="RealtyValuationBlock">
      <Section data-nav-tab="realty-valuation/Динамика цен" id="realty-valuation">
        {children}
      </Section>
    </LayoutBlock>
  );
}
